import React, { useEffect, useRef } from 'react';

import { cssMap } from '@atlaskit/css';
import { ButtonItem } from '@atlaskit/menu';
import { Box, Stack } from '@atlaskit/primitives/compiled';
import { token } from '@atlaskit/tokens';

const styles = cssMap({
	outerContainerStyles: {
		width: '100%',
		alignItems: 'center',
		justifyItems: 'center',
	},

	containerStyles: {
		width: '354px',
		borderRadius: token('border.radius.200'),
		borderWidth: token('border.width'),
		borderColor: token('color.border'),
		borderStyle: 'solid',
	},

	contentStyles: {
		paddingTop: token('space.150'),
		paddingRight: token('space.150'),
		paddingBottom: token('space.150'),
		paddingLeft: token('space.150'),
		display: 'flex',
		alignItems: 'left',
		justifyItems: 'center',
	},

	promptTextStyles: {
		maxWidth: '332px',
		overflow: 'hidden',
		whiteSpace: 'nowrap',
		textOverflow: 'ellipsis',
	},
});

const BaseConvoActionItem = ({ title, icon }: { title: string; icon: React.ReactElement }) => {
	return (
		<Box xcss={styles.containerStyles}>
			<Stack xcss={styles.contentStyles} space="space.050">
				{icon}
				<Box xcss={styles.promptTextStyles}>{title}</Box>
			</Stack>
		</Box>
	);
};

export function ConvoStarterItem({
	title,
	icon,
	isSelected,
	onClick,
	type,
}: {
	title: string;
	icon: React.ReactElement;
	isSelected: boolean;
	onClick?: () => void;
	type: string;
}) {
	const ref = useRef<HTMLElement>(null);
	useEffect(() => {
		if (isSelected && ref.current) {
			ref.current.scrollIntoView({
				behavior: 'instant',
				block: 'nearest',
			});
		}
	}, [isSelected, ref]);

	const item = <BaseConvoActionItem title={title} icon={icon} />;

	return (
		<ButtonItem ref={ref} onClick={onClick} isSelected={isSelected}>
			{item}
		</ButtonItem>
	);
}
